import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdates from './components/LatestUpdates';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩漫之家 - 韩漫网站_韩漫在线观看_免费漫画下拉式阅读"
        description="韩漫之家作为专业的韩漫网站，专注于免费下拉式漫画在线观看，采用智能加载技术，确保阅读体验流畅舒适。提供海量热门韩漫、最新更新韩漫，支持手机和电脑在线观看。"
        keywords="韩漫网站,韩漫在线观看,免费漫画,下拉式,韩漫之家,智能加载,阅读体验,流畅舒适"
        canonical="https://hanmanzhijia.com/"
        ogImage="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20reading%20platform%20with%20warm%20cozy%20atmosphere%2C%20comic%20books%20shelf%20background%2C%20soft%20lighting%2C%20modern%20digital%20reading%20experience%2C%20artistic%20illustration%20style&width=1200&height=630&seq=og-home-2026&orientation=landscape"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '韩漫之家 - 首页',
          description: '韩漫之家是专业的韩漫在线阅读平台，提供免费下拉式漫画在线观看服务。',
          url: 'https://hanmanzhijia.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫之家',
            url: 'https://hanmanzhijia.com/',
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            { '@type': 'Question', name: '韩漫之家是完全免费的吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，韩漫之家所有漫画资源均免费向用户开放，无需付费即可享受完整的在线阅读体验。' } },
            { '@type': 'Question', name: '什么是下拉式阅读模式？', acceptedAnswer: { '@type': 'Answer', text: '下拉式阅读是韩漫之家独有的阅读模式，您只需向下滑动页面即可连续阅读，无需点击翻页按钮。配合智能加载技术，系统会提前预加载后续内容，确保阅读过程流畅无卡顿。' } },
            { '@type': 'Question', name: '漫画更新频率是怎样的？', acceptedAnswer: { '@type': 'Answer', text: '韩漫之家与多家韩漫版权方保持密切合作，热门漫画基本可以实现与韩国同步更新。一般工作日内每日都有新内容上架。' } },
            { '@type': 'Question', name: '支持手机端阅读吗？', acceptedAnswer: { '@type': 'Answer', text: '韩漫之家采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您使用什么设备访问，都能获得流畅舒适的下拉式阅读体验。' } },
            { '@type': 'Question', name: '如何搜索我想看的漫画？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过网站顶部的搜索框输入漫画名称或作者名进行搜索，也可以通过分类导航按类型筛选感兴趣的漫画。' } },
            { '@type': 'Question', name: '遇到加载问题怎么办？', acceptedAnswer: { '@type': 'Answer', text: '如果您在使用过程中遇到加载缓慢或无法显示的问题，建议检查网络连接状态，或尝试刷新页面。如问题持续存在，可以通过关于我们页面的联系方式向我们反馈，我们会尽快处理。' } },
          ],
        }}
      />

      <header>
        <Navbar transparent />
      </header>

      <main>
        <HeroSection />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdates />
        <TestimonialsSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}